import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Page, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SliceLayoutBoundary, SiteHeaderLayout, EntityBannerProps, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutProps, ComponentPropsProvider, PAGE_HOME, BackButtonEntityProvider, SvgCanvasViewBoxDefinition, DownloadButton, useLang, useAuth, SiteHeaderProvider, ExplorerTabs } from '@shapeable/ui';
import { ExplorerProvider } from '../providers/explorer-provider';
import { ValueChainNavigator } from '../elements/value-chain-navigator';
import { ValueChainNavigatorMain } from '../elements/value-chain-navigator-main';
const cls = classNames('page-explorer-layout');

// -------- Types -------->

type RadarProps = {
  isInteractive: boolean;
}

// -------- Props -------->

export type PageExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & {  
  entity?: Page;
  bannerProps?: Omit<EntityBannerProps, 'entity'>;
  showRadar?: boolean;
  isAsideSticky?: boolean;
};

export const PageExplorerLayoutDefaultProps: Omit<PageExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
  isAsideSticky: false,
  showRadar: true,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};

    .shp--entity-banner {
      h2.shp--entity-value__name {
        font-size: ${theme.FONT_SIZE(28)};
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});


const NavigatorStyles = breakpoints({
  base: css`

  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
      Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
      Navigator: styled(ValueChainNavigator)`${NavigatorStyles}`,

      
};

export const PageExplorerLayout: Shapeable.FC<PageExplorerLayoutProps> = (props) => {
  const { className, children, entity, bannerProps, showRadar, isAsideSticky, ...explorerEntityDetailsProps } = props;

  const t = useLang();

  const auth = useAuth();

  return (
    <ExplorerProvider>
    <SiteHeaderProvider value={{ 
      variant: 'default',
    }}>
    <BackButtonEntityProvider value={entity.parent}>
    <My.Container>
      <ComponentPropsProvider value={{
        EntityBanner: {
          variant: 'image',
          maxHeight: 400,
          showSubheader: true,
          useBackgroundColor: false,
          entityValueProps: { showImage: false, showOutlineNumber: false }
        },
      }}>
      <My.Header />
      <My.Tabs useStickyStyle />
      <SliceLayoutBoundary boundary='none' >
        <My.Layout 
          entity={entity}
          className={cls.name(className)}
          {...explorerEntityDetailsProps}
          useMaxWidth={false}
          split={[4.5, 5.5]}
          isAsideSticky={true}
          stickyTopOffset={64}

          dataVizMain={
            <ValueChainNavigatorMain />
          }
  
          //aside
          dataViz={
            <My.Navigator />
          }
        />
        </SliceLayoutBoundary>
      </ComponentPropsProvider>
    </My.Container>
    </BackButtonEntityProvider>
    </SiteHeaderProvider>
    </ExplorerProvider>
  )
};

PageExplorerLayout.defaultProps = PageExplorerLayoutDefaultProps;
PageExplorerLayout.cls = cls;